import React from 'react'
import View from 'components/View'
import './index.css'
import useSelector from 'hooks/use-selector'
import hasMembersSquadSelect from 'modules/squad/redux/selectors/has-members'
import AddYourFirstFriendToYourSquadContent from 'containers/AddYourFirstFriendToYourSquad/components/Content'
import SquadPageYouVeAddedFriendsToYourSquad from 'pages/Squad/containers/Friends/YouVeAddedFriendsToYourSquad'
import SquadPageGetBonusPointsWhenYouInviteANewFriendPopover from 'pages/Squad/containers/Friends/GetBonusPointsWhenYouInviteANewFriendPopover'
import SquadPageFriendNames from 'pages/Squad/containers/Friends/Names'
import SquadPageCurrentFriendSuperLikedSamples from 'pages/Squad/containers/Friends/CurrentFriendSuperLikedSamples'
import SquadPageCurrentFriendLikedSamples from 'pages/Squad/containers/Friends/CurrentFriendLikedSamples'
import SquadPageCurrentFriendSampleSummary from 'pages/Squad/containers/Friends/CurrentFriendSampleSummary'
import SquadPageCurrentFriendHasNotTriedSamplesYet from 'pages/Squad/containers/Friends/CurrentFriendHasNotTriedSamplesYet'
import HandleHashChange from 'containers/HandleHashChange'

export default function SquadPageFriends () {
  const hasMembers = useSelector(hasMembersSquadSelect)
  const debugProps = {
    hasMembers
  }
  logUtil('SquadPageFriends').debug('[start] debugProps=', debugProps)

  return (
    <View className='squad-friends'>
      {
        hasMembers
          ? (
            <>
              <SquadPageYouVeAddedFriendsToYourSquad />
              <SquadPageGetBonusPointsWhenYouInviteANewFriendPopover />
              <SquadPageFriendNames />
              <SquadPageCurrentFriendHasNotTriedSamplesYet />
              <SquadPageCurrentFriendSampleSummary />
              <SquadPageCurrentFriendSuperLikedSamples />
              <SquadPageCurrentFriendLikedSamples />
              <HandleHashChange />
            </>
            )
          : <AddYourFirstFriendToYourSquadContent showRatingCardOnMobile />
      }
    </View>
  )
}
